import React from 'react';
import { CoverHero } from './components/CoverHero';
import { StrategicIntent } from './components/StrategicIntent';
import { TheJourney } from './components/TheJourney';
import { LayerHollywood } from './components/LayerHollywood';
import { LayerMenu } from './components/LayerMenu';
import { LayerCore } from './components/LayerCore';
import { LayerXRay } from './components/LayerXRay';
import { Closing } from './components/Closing';
import { TextVersionToggle } from './components/TextVersionToggle';
import { RhetoricCompass } from './components/RhetoricCompass';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <TextVersionToggle data-id="element-1" />
      <RhetoricCompass data-id="element-2" />
      <CoverHero data-id="element-3" />
      <StrategicIntent data-id="element-4" />
      <TheJourney data-id="element-5" />
      <LayerHollywood data-id="element-6" />
      <LayerCore data-id="element-7" />
      <LayerXRay data-id="element-8" />
      <LayerMenu data-id="element-9" />
      <Closing data-id="element-10" />
    </div>;
}